// extracted by mini-css-extract-plugin
module.exports = {"countDown":"CountDown_countDown__1L9R3","times":"CountDown_times__1_Gdc","time":"CountDown_time__1jWYP"};